<template>
  <base-spinner :open="isloading"></base-spinner>
  <base-dialog title="Select Duplicate Item" @close="closeDialog" :open="openPartsDialog" :title-class="'card-title-modal'">
    <template #default>
      <div class="table-responsive">
        <table class="table" v-if="partsList.length > 0">
          <thead>
            <tr>
              <th></th>
              <th>Item</th>
              <th>Manufacturer</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(part, index) in partsList" :key="index">
              <td>
                <button class="add-to-cart-icon" type="button" aria-label="Add to cart" @click="selectPart(index)">
                    <svg width="20" height="20">
                        <circle cx="7" cy="17" r="2"></circle>
                        <circle cx="15" cy="17" r="2"></circle>
                        <path
                            d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
                            V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
                            C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                            ></path>
                    </svg>
                </button>
              </td>
              <td>{{ part.item }}</td>
              <td>{{ part.manufacturerdesc }}</td>
              <td>{{ part.itemdesc }}</td>
            </tr>

          </tbody>
        </table>
        <p class="text-center" v-else>
          No items found.
        </p>
      </div>
      <!-- <ul class="list-unstyled">
        <li v-for="manufacturer in partsList" :key="manufacturer.manufacturer">
          <label>
            <input type="radio" v-model="selectedPart" :value="manufacturer.manufacturer" /> {{ manufacturer.manufacturer }}
          </label>
        </li>
      </ul> -->
      <!-- <label class="radio" v-for="manufacturer in partsList" :key="manufacturer.manufacturer">
        <input type="radio" class="form-control" v-model="selectedPart" :value="manufacturer.manufacturer" /> {{ manufacturer.manufacturer }}
      </label> -->
    </template>
    <template #actions>
      <button type="button" class="btn btn-sm btn-secondary" @click="closeDialog">
        Cancel
      </button>
    </template>
  </base-dialog>
  <insufficient-on-hand-dialog :openInsufficientOnHandDialog="openInsufficientOnHandDialog" :partsList="insufficientPartsList" :sourcePage="'OrderParts'" @closeInsOnHandDialog="closeInsOnHandDialog"/>
  <div class="block">
    <div class="container">
      <div>
        <div class="widget-form-panel-mobile">
          <div class="container-form order-entry-form-container">
            <form class="order-entry-table__form">

                <div class="container-form-field has-icon" :class="{ invalid: searchKeywordValid === 'invalid' }">
                    <input type="text" class="form-control form-control-order-entry-field" placeholder="Enter Item Number or Description" 
                        v-model.trim="searchKeyword"
                        @keypress.enter.prevent="addItem()"
                    />
                    <ul class="dropdown-menu" style="width:100%" v-bind:class="{'open':openSuggestion}">
                        <li v-for="(suggestion, index) in api_results" :key="index" 
                        v-bind:class="{'active': isActive(index)}"
                        @click="suggestionClick(suggestion)">
                            <a href="#" class="notranslate">{{ suggestion }}</a>
                        </li>
                    </ul>
                    <small class="invalid-text" v-if="searchKeywordValid === 'invalid'">
                        <i>Please enter a keyword and a valid quantity.</i>  
                    </small>
                </div>

                <div class="container-form-field order-parts-qty">
                    QTY:
                </div>
                <div class="container-form-field" :class="{ invalid: searchKeywordValid === 'invalid' }">
                    <input type="text" class="form-control form-control-order-entry-field-qty" placeholder="QTY" v-model="requestedQuantity" @keypress.enter.prevent="addItem()">
                </div>
            </form>
          </div>
          <div class="block-space--layout--divider-5"></div>
          <div class="row order-parts-search-bar">
            <div class="col-md-12">
                <button type="button" class="btn btn-xs btn-checkout"  @click="addItem()">Add Item</button>
                <a href="javascript:void(0)" class="btn btn-xs btn-primary mr-20" @click.prevent="searchProduct">Search</a>
                <a href="javascript:void(0)" class="btn btn-xs btn-blue" v-if="userIsAuthenticated" @click="saveOrder">Save Order</a>
                <a href="javascript:void(0)" class="btn btn-xs btn-blue" v-if="showCheckStock" @click="gotoStockOrder">Stock Order</a>
            </div>
        </div>

        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import InsufficientOnHandDialog from "./InsufficientOnHandDialog";
import MixinCart from '../../../mixins/cart.js';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            searchKeyword: '',
            searchKeywordValid: 'pending',
            requestedQuantity: 0,
            openPartsDialog: false,
            openInsufficientOnHandDialog: false,
            partsList: [],
            insufficientPartsList: {},
            selectedPart: null,
            isloading: false,
            isKit: '',
            servermessages: [],

            // data for auto complete
            open: false,
            current: 0,
            selected: null,
            api_results: [],
            product: {},
        }
    },
    components: {
        "insufficient-on-hand-dialog": InsufficientOnHandDialog
    },
    emits: ['show-messages'],
    mixins : [
        MixinCart
    ],
    props: {
        sourcePage: {
            type: String
        },
    },
    methods: {
        saveOrder() {
            this.isloading = true;
            let parts = [];

            this.cart.forEach(cartitem => {
            parts.push([
                cartitem.manufacturer, 
                cartitem.item,
                cartitem.quantity,
                "",
                ""
            ]);
            });

            axiosvl.post(this.$store.getters['api/add_saved_order_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "EHPONO": {"value": "TEST PO - LANSA"},
                        "EHCARR": {"value": " "}
                    },
                    "lists": {
                            "PARTSO": {
                                "header": [
                                    {"name": "EKMFGC"},
                                    {"name": "EKITMC"},
                                    {"name": "EKOQTY"},
                                    {"name": "EKCPO#"},
                                    {"name": "EKLOCN"}
                                ],
                                "entries": parts
                            }
                        }
                }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields
                if (fields.RESULTCOD.value === 'OK') {
                this.servermessages.push("Your order has been saved successfully.");
                } else {
                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                for (var i = 0; i < wrmessages.length; i++) {
                    messages.push(wrmessages[i]);
                }

                // Return code is not "OK" but no messages appear, add a custom error message
                if (messages.length === 0) {
                    messages.push("Something went wrong. Please try again later.");
                }
    
                this.servermessages = messages;
                }

                // !NC!
                if (this.servermessages.length > 0) {
                this.servermessages.forEach(message => {
                    alert(message);
                });
                }

                this.isloading = false;
            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },
        validateSearchKeyword() {
            if (this.searchKeyword === "" || !(this.requestedQuantity > 0)) {
                this.searchKeywordValid = "invalid";
            } else {
                this.searchKeywordValid = "valid";
            }
        },
        searchProduct() {
            this.validateSearchKeyword();

            if (this.searchKeywordValid === 'valid') {
                let url = '/keyword-search-results?search=' + this.searchKeyword;
                this.$router.push(url);
            }
        },
        addItem() {
            this.open = false;
            this.insufficientPartsList = {};
            this.openInsufficientOnHandDialog = false;
            this.validateSearchKeyword();

            if (this.searchKeywordValid === 'invalid') {
                return;
            }
            
            this.isloading = true;
            this.openPartsDialog = false;
            
            this.partsList = [];
            this.$emit("show-messages", []);

            axiosvl.post(this.$store.getters['api/duplicate_items_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "EIITMC": { "value": this.searchKeyword }
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                const messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    const IMKITM = fields.   IMKITM.value;
                    // hardcoded for kit item
                    // need to identify how product being parts or a kit
                    if(IMKITM == 'Y'){
                        this.isKit = true;
                        this.$emit('isKit', this.isKit);

                        this.$router.push('/keyword-search-results?search=' + this.searchKeyword);
                    }

                    this.searchKeyword = '';
                    const results = [];
                    let listcount = 0;

                    for (const key in response.data.webroutine.lists.MPARTS.entries) {
                        const obj = response.data.webroutine.lists.MPARTS.entries[key];

                        results.push({
                            manufacturer: obj.EIMFGC,
                            manufacturerdesc: obj.MCNAME,
                            item: obj.EIITMC,
                            itemdesc: obj.IMDESC,
                            stockquantity: obj.QTYAVL,
                            location: obj.CMDLOC,
                            requestedquantity: this.requestedQuantity,

                            XRMFGC: obj.XRMFGC,
                            XRITMC: obj.XRITMC,
                            IMIGSA: obj.IMIGSA,
                            IMISVALID: obj.IMISVALID,
                        });
                        listcount++;
                    }

                    if (listcount === 1) {
                        if (this.customerIndicator === 'B') {
                            if (this.requestedQuantity > results[0].stockquantity) {
                                this.insufficientPartsList = results[0];
                                this.openInsufficientOnHandDialog = true;
                            } else {
                                this.addToCart(results[0].manufacturer, results[0].item);
                            }
                        // this.confirmSelect(results[0].manufacturer, results[0].item);
                        } else {
                            this.addToCart(results[0].manufacturer, results[0].item);
                        }
                    } else if (listcount > 1) {
                        this.openPartsDialog = true;
                        this.partsList = results;
                    } else {
                        messages.push("Something went wrong. Please try again later.");
                    }

                } else {
                    // this.addPartsLinkItem();
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;

                this.$emit('show-messages', this.servermessages);
            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },

        addPartsLinkItem() {
            this.open = false;
            this.insufficientPartsList = {};
            this.openInsufficientOnHandDialog = false;
            const catpn = this.$store.getters['storeConfigID'];
            this.validateSearchKeyword();

            if (this.searchKeywordValid === 'invalid') {
                return;
            }
            
            this.isloading = true;
            this.openPartsDialog = false;
            
            this.partsList = [];
            this.$emit("show-messages", []);

            axiosvl.post(this.$store.getters['api/pl_itemsearch_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN" : { "value": catpn},
                        "SRCITM": { "value": this.searchKeyword },
                    }
                }
            })
            .then((response) => {
                // console.log(response);
                const fields = response.data.webroutine.fields
                const messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    // console.log(response);

                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;

                this.$emit('show-messages', this.servermessages);
            })
            .catch((error) => {
            this.isloading = false;
                console.log("error - " + error);
            });
        },
        addToCart(manufacturer, item) {
            this.isloading = true;
            this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);

            // check first if item is already in the cart
            const cart_items = this.$store.getters['cart/cart'];

            // update the cart item
            if(cart_items.length > 0){
                const filtered_items = cart_items.filter(i => i.item ==  item);
                if (filtered_items.length > 0){
                    const update_product = filtered_items[0];
                    update_product.quantity += 1;
                    update_product.isupdating = true;
                    this.isloading = false;
                    this.$store.dispatch("cart/updateCart", update_product);
                    return;
                }
            }

            axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": manufacturer },
                        "EIITMC": { "value": item },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {

                    const linetotal = this.requestedQuantity * fields.EIEXCP.value;
                    const defaultLoc = this.$store.getters.getCustomerDetails;

                    this.product = {
                        ID: fields.IMITMC.value,
                        IMITMC: fields.IMITMC.value,
                        item: fields.IMITMC.value,
                        desc: fields.IMDESC.value,
                        manufacturer: fields.IMMFGC.value,
                        // image: fields.EPIMG1.value,
                        image: null,
                        quantity: this.requestedQuantity,
                        corecharge: fields.EICORP.value,
                        yourprice: fields.EIEXCP.value,
                        listprice: fields.EILSTP.value,
                        shipping: 0,
                        linetotal: linetotal,

                        // from Nic @ issue #260
                        // if it is B2B use QTYAVL
                        // if it is B2C use TOTOH
                        stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                        // locationid: fields.CMDLOC.value,
                        locationid: defaultLoc,
                        locationname: defaultLoc.defaultlocationname,
                        locationcity: defaultLoc.defaultlocationcity,
                        locationstate: defaultLoc.defaultlocationstate,

                        XRMFGC: fields.XRMFGC.value,
                        XRITMC: fields.XRITMC.value,
                        IMIGSA: fields.IMIGSA.value,
                        IMISVALID: fields.IMISVALID.value,
                    };

                    // console.log(this.product);

                    let validationresult = this.addToCartValidation(this.product);

                    if (validationresult.status === 'OK') {
                        
                        this.searchKeyword = '';
                        // setTimeout(() => {
                            this.$store.dispatch("cart/addToCart", this.product);
                            this.isloading = false;
                        // }, 1000);
                        
                    } else {
                        let storedmessages = [];
                        storedmessages.push(validationresult.message);

                        this.$store.dispatch("message/addKeyedMessage", {
                            "key": this.sourcePage,
                            "messages": storedmessages
                        });

                        this.isloading = false;
                    }
                }else{
                    this.isloading = false;
                }

                this.searchKeyword = '';
                this.requestedQuantity = 1;

            })
            .catch((error) => {
                console.log("error - " + error);
            });

        },
        selectPart(index) {
            this.openPartsDialog = false;
            this.insufficientPartsList = this.partsList[index];

            if (this.customerIndicator === 'B') { 
                if (this.requestedQuantity > this.insufficientPartsList.stockquantity) {
                    this.openInsufficientOnHandDialog = true;
                } else {
                     this.addToCart(this.insufficientPartsList.manufacturer, this.insufficientPartsList.item);
                }
            } else {
                this.addToCart(this.insufficientPartsList.manufacturer, this.insufficientPartsList.item);
            }

            this.closeDialog();
        },
        closeDialog() {
            this.selectedPart = null;
            this.openPartsDialog = false;
        },
        confirmSelect(manufacturer, item) {
            this.openPartsDialog = false;
            let url = '/order-entry-check-stock/' + manufacturer + '/' + item;
            this.$router.push(url);
        },
        closeInsOnHandDialog(clearValues) {
            if (clearValues) {
                this.searchKeyword = '';
                this.requestedQuantity = 1;
            }
            this.openInsufficientOnHandDialog = false;
        },

        gotoStockOrder() {
            this.$router.push('/stock-order');
        },

        /**
         * Autocomplete suggestions methods
         */

        // to call the api to search string
        api() {

            if (this.searchkeyword == ''){
                return false;
            }

            // console.log('api method');
            axiosvl.post(this.$store.getters['api/search_typeahead_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							"EHCUST": {
								"value": this.$store.getters.customer
								// "value": "DMS"
							},
                            "TYPEAHEAD" : {
                                "value": this.searchKeyword
                            }
						}
					}
				}
			).then((response) => { 
                const fields = response.data.webroutine.fields;
                this.api_results = [];
				for (const key in response.data.webroutine.lists.PDESCS.entries) { 
					const obj = response.data.webroutine.lists.PDESCS.entries[key];
                    
                    this.api_results.push(obj.TADESCR);	
				}

                if (fields.NREC.value > 0){
                    this.open = true;
                }

			}).catch(function (error) { 
				console.log("error - " + error);
			});
        },

        //When up pressed while suggestions are open
        up() {
            if(this.current > 0)
                this.current--;
        },

        //When up pressed while suggestions are open
        down() {
            if(this.current < this.api_results.length - 1)
                this.current++;
        },

        //For highlighting element
        isActive(index) {
            return index === this.current;
        },

        //When the user changes input
        change() {
            // console.log('change');
            this.api();
            if (this.open == false) {
                this.open = true;
                this.current = 0;
            }
        },

        //When one of the suggestion is clicked
        suggestionClick(select) {
            this.searchKeyword = select;
            // this.searchKeyword = '';
            this.selected = select;
            this.open = false;
            this.addItem();
        },

        //When enter pressed on the input
        keywordSearch() {
            this.selected = this.api_results[this.current];
            this.searchKeyword = this.api_results[this.current];
            // this.searchKeyword = '';
            this.open = false;
            this.addItem();
        },
    },
    computed:{
        ...mapGetters([
          'userIsAuthenticated',
          'customerIndicator',
          'storefrontAttributes'
        ]),
        ...mapGetters("cart", [
            "cart",
            "totals"
        ]),
        // ...mapGetters('cart', [
        //     'cart',
        // ]),
        showCheckStock() {
            if (this.storefrontAttributes.length > 0) {
                let onHandQuantityRule = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ').value;
                return this.customerIndicator === 'B' && onHandQuantityRule != '5';
            } else {
                return false;
            }
        },
        //The flag
        openSuggestion() {
            return this.api_results.length != 0 &&
                this.open === true;
        }
    },
    created() {
        this.searchKeyword = '', this.selectedPart = null;
        this.searchKeywordValid = 'pending';
        this.openPartsDialog, this.openInsufficientOnHandDialog, this.isloading = false;

        this.requestedQuantity = 1;
    }
}
</script>

<style scoped>
    .mr-20{
        margin-right: 20px;
    }

    #dialog-manufacturer-list {
        min-width: 500px;
    }

    .container-form-field.has-icon {
        position: relative;
    }

    .container-form-field.invalid input,
    .container-form-field.invalid label {
        border-color: #cb1818;
    }

    .container-form-field.invalid label,
    .container-form-field.invalid .invalid-text {
        color: #cb1818;
    }
        .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 160px;
        padding: 5px 0;
        margin: 2px 0 0;
        font-size: 14px;
        text-align: left;
        list-style: none;
        background-color: #fff;
        -webkit-background-clip: padding-box;
                background-clip: padding-box;
        border: 1px solid #ccc;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
                box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    }

    .dropdown-menu.pull-right {
        right: 0;
        left: auto;
    }
    .dropdown-menu .divider {
        height: 1px;
        margin: 9px 0;
        overflow: hidden;
        background-color: #e5e5e5;
    }
    .dropdown-menu > li > a {
        display: block;
        padding: 3px 20px;
        clear: both;
        font-weight: normal;
        line-height: 1.42857143;
        color: #333;
        white-space: nowrap;
    }
    .dropdown-menu > li > a:hover,
    .dropdown-menu > li > a:focus {
        color: #262626;
        text-decoration: none;
        background-color: #f5f5f5;
    }
    .dropdown-menu > .active > a,
    .dropdown-menu > .active > a:hover,
    .dropdown-menu > .active > a:focus {
        color: #fff;
        text-decoration: none;
        background-color: #337ab7;
        outline: 0;
    }
    .dropdown-menu > .disabled > a,
    .dropdown-menu > .disabled > a:hover,
    .dropdown-menu > .disabled > a:focus {
        color: #777;
    }
    .dropdown-menu > .disabled > a:hover,
    .dropdown-menu > .disabled > a:focus {
    text-decoration: none;
        cursor: not-allowed;
        background-color: transparent;
        background-image: none;
        filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
    }
    .dropdown-menu.open {
        display: block;
    }
    .open > a {
        outline: 0;
    }
    .dropdown-menu-right {
        right: 0;
        left: auto;
    }
    .dropdown-menu-left {
        right: auto;
        left: 0;
    }
    .dropdown-header {
        display: block;
        padding: 3px 20px;
        font-size: 12px;
        line-height: 1.42857143;
        color: #777;
        white-space: nowrap;
    }
    .dropdown-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 990;
    }
    .pull-right > .dropdown-menu {
        right: 0;
        left: auto;
    }
    .dropup .caret,
    .navbar-fixed-bottom .dropdown .caret {
        content: "";
        border-top: 0;
        border-bottom: 4px dashed;
        border-bottom: 4px solid \9;
    }
    .dropup .dropdown-menu,
    .navbar-fixed-bottom .dropdown .dropdown-menu {
        top: auto;
        bottom: 100%;
        margin-bottom: 2px;
    }
    @media (min-width: 768px) {
        .navbar-right .dropdown-menu {
            right: 0;
            left: auto;
        }
        .navbar-right .dropdown-menu-left {
            right: auto;
            left: 0;
        }
    }
</style>